document.addEventListener('DOMContentLoaded', function () {
    const initialDuration = 60 * 60; // 60 minutes in seconds
    const repeatDuration = 10 * 60; // 10 minutes in seconds
    const timers = document.querySelectorAll('#countdown-timer');
    const STORAGE_KEY = 'cart_countdown_expiry';

    // Helper to get expiry timestamp from localStorage or set it if not present
    function getOrSetExpiry() {
        let expiry = localStorage.getItem(STORAGE_KEY);
        const now = Math.floor(Date.now() / 1000);

        // If expiry not set or in the past, set new expiry
        if (!expiry || Number(expiry) < now) {
            expiry = now + initialDuration;
            localStorage.setItem(STORAGE_KEY, expiry);
        }
        return Number(expiry);
    }

    function startCountdown(display, expiry, repeatSeconds) {
        let interval = setInterval(() => {
            const now = Math.floor(Date.now() / 1000);
            let remaining = expiry - now;

            if (remaining < 0 && repeatSeconds) {
                expiry = now + repeatSeconds;
                localStorage.setItem(STORAGE_KEY, expiry);
                remaining = repeatSeconds;
                repeatSeconds = null; // Only repeat once
            }

            if (remaining < 0) {
                clearInterval(interval);
                display.textContent = "00:00";
                return;
            }

            const minutes = Math.floor(remaining / 60);
            const secs = remaining % 60;
            display.textContent =
                `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')} minutes`;
        }, 1000);
    }

    timers.forEach(function (timer) {
        const expiry = getOrSetExpiry();
        startCountdown(timer, expiry, repeatDuration);
    });
});

document.addEventListener('variant:change', function(event) {
  var variantId = event.detail && event.detail.variant ? event.detail.variant.id : null;
  if (!variantId) return;
  var productImagesContainer = document.querySelector('[data-product-images]');
  if (!productImagesContainer) return;

  fetch(window.location.pathname + '?variant=' + variantId)
    .then(function(response) { return response.text(); })
    .then(function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newImages = doc.querySelector('[data-product-images]');
      if (newImages) {
        productImagesContainer.innerHTML = newImages.innerHTML;

        // ✅ Get slideshow + thumbs
        var slideshowEl = productImagesContainer.querySelector('.product-slideshow');
        var thumbsContainer = productImagesContainer.querySelector('[data-product-thumbs]');

        if (slideshowEl) {
          new theme.Slideshow(slideshowEl, {
            adaptiveHeight: true,
            fade: false,
            wrapAround: true,
            childNav: thumbsContainer, // ✅ hook thumbs back in
            childNavScroller: thumbsContainer ? thumbsContainer.querySelector('.product__thumbs--scroller') : null,
            childVertical: false
          });
        }

        // ✅ Re-initialize theme.Product for product section after DOM update
        var productSection = productImagesContainer.closest('[data-section-id]');
        if (window.theme && typeof theme.Product === 'function' && productSection) {
          new theme.Product(productSection);
        }
      }
    });
});


